import React, { Suspense } from 'react';
import TopBar from './component/topbar';

// Dynamically import the EditorWithStore component
const DynamicEditor = React.lazy(() =>
  import('../../components/Editor').then((module) => ({ default: module.EditorWithStore }))
);

function EditorPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className='mb-1'>
      <TopBar/>
      </div>
      <DynamicEditor />
    </Suspense>
  );
}

// Correctly set the display name
EditorPage.displayName = "EditorPage";

export default EditorPage;
